import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { DataTableComponent } from '../data-table.component';

@Component({
    selector: 'app-column',
    template: ``,
    standalone: false
})
export class ColumnComponent {
	@Input() value: string;
	@Input() header: string;
	@Input() title: string;
	@Input() isSortable: boolean;
	@Input() sortFn: (a: any, b: any, ascending: boolean) => number;
	@Input() isFilterable: boolean;
	@Input() expandContent: TemplateRef<any>;
	@Input() width: string;
	@Input() isFilterIconVisible: boolean;
	@Input() isSortIconVisible: boolean;

	@ContentChild('tableBodyTemplate') bodyTemplate: TemplateRef<any>;

	constructor(public table: DataTableComponent) {
	    table.addColumn(this);
	}
}
